<template>
    <div>
    <nav class="bread-nav" aria-label="You are here:" role="navigation">
      <ul class="breadcrumbs">
        <li><router-link :to="{name:'Index'}">ホーム</router-link></li>
        <li><router-link :to="{name:'DayRaceList',params:{date:date}}"> レース一覧 {{ date.substr(0,4)+'年' + date.substr(4,2)+'月'+ date.substr(6,2)+'日'}}</router-link></li>
        <li><router-link :to="{name:'JoDateIndex',params:{date:date,jo:jo}}"> {{ jo_name }}</router-link></li>
        <li><span class="show-for-sr">Current: </span> {{ race.rno }}R 出走表</li>
      </ul>
    </nav>
    <nav class="jo-date-nav">
      <ul class="menu jo-date-menu" v-if="nidate_length > 0" >
        <li v-for="ni of nidate_length" :key='ni' >
          <span v-if="header['nidate'+ni+'_ready']"><router-link class="button" :class="race.nj == ni ? 'current':''" :to="{name:'JoDateIndex',params:{jo:jo,date:race['nidate'+ni].replace(/\-/g,'')}}">{{  Number(race['nidate'+ni].substr(5,2))+'月'+  Number(race['nidate'+ni].substr(8,2))+'日'  }}</router-link></span>
          <span v-else><span class="button" disabled>{{   Number(race['nidate'+ni].substr(5,2))+'月'+  Number(race['nidate'+ni].substr(8,2))+'日'  }}</span></span>
        </li>
      </ul>
    </nav>
    
    <nav class="race-nav">
      <ul class="menu race-num-menu" v-if="nidate_length > 0" >
        <li v-for="ri in 12" :key='ri' >
          <router-link class="button" v-if="ri != race.rno" :to="{name:'KisyaYoso',params:{date:date,jo:jo,race:ri}}">{{ ri }}R</router-link>
          <span class="button current" v-else>{{ ri }}R</span>
        </li>
      </ul>
    </nav>
    
    <div class="race-header">
        <h1 class="race-h1">
          <div class="jo-name">{{ jo_name }}</div>
          <div class="race-number">{{ race.rno }}R</div>
          <div class="race-date">{{ date.substr(0,4)+'年' + date.substr(4,2)+'月'+ date.substr(6,2)+'日'}}</div>
          <div class="race-ktitl">{{ race.ktitl }}</div>
        </h1>
    
        <div class="rmei-rsname">
          <span class="race-rmei">{{ race.rmei }}</span> <span class="race-rsname">{{ race.rsname }} <span :class="race.kyori < 1800 ?'genshu':'' ">{{ race.kyori }}m</span> <span v-if="race.kyori < 1800">減周回</span></span>
        </div>
    </div>

    <div class="kisya-yoso-column" v-if="yoso_article.length >0">
        <div class="kisya-yoso-column__inner">
        <h2><img src="/images/hochi_logo.svg" alt="スポーツ報知" class="hochi-logo"  /> 記者直前予想</h2>   
       
        <p v-for="(line, index) in yoso_article" :key="index">
           <span v-html="line"></span>
        </p>
        </div>
    </div>

    <div class="race-sh-times">
      <div>締切時刻 {{ race.stime ? race.stime.split('T')[1].slice( 0, -3 ):'-' }}</div>
          <!-- <div>出走時刻 {{ race.htime ? race.htime.split('T')[1].slice( 0, -3 ):'' }}</div> -->
    </div>
    
    
    <Racenav :current = "'kisya_yoso'" :racedate = "date" :joid= "jo" :rno = "race_num" :is_result_available = "race.is_result_available" :has_chokuzen_yosou ="race.has_chokuzen_yosou"></Racenav>
    
    <div class="table-scroll">
    <table class="shussou-table">
      <thead>
      <tr>
        <th class="my-sirusi">My印</th>
        <th class="waku">枠</th>
        <th class="text-vertical"><span>当日予想</span></th>
        <th class="text-vertical"><span>気配</span></th>
        <th class="text-vertical"><span>モーター</span></th>
        <th></th>
        <th style="white-space: nowrap;">氏名<br /> 登録番号/級別</th>
        <th class="sp-comment-cell">コメント</th>
        <th style="white-space: nowrap;">支部/出身地<br />年齢/体重</th>
        <th style="white-space: nowrap;">F数<br />L数<br />平均ST</th>
        <th style="white-space: nowrap;">全国<br />勝率<br />2連率<br />3連率</th>
        <th style="white-space: nowrap;">当地<br />勝率<br />2連率<br />3連率</th>
        <th style="white-space: nowrap;">モーター<br />No<br />2連率</th>
        <th style="white-space: nowrap;">ボート<br />No<br />2連率</th>
        <th class="comment-cell" style="white-space: nowrap;">コメント</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(senshu,index) in shussou_senshu">
      <tr :key="`m_${senshu.name}`" :class="(senshu.kjo == 1)?'kjo':''">
        <td  class="my-sirusi">
          <div v-if="$store.getters.user !=null ">
          <a class="open-sirusi-button" v-on:click="openMySirusiSelecor(index+1)" :class=" printMySirusi(my_sirusi[index]) == 'ー' ? 'notset':''">{{  printMySirusi(my_sirusi[index]) }}</a>
          <div :id="'my_sirusi_selector_'+index" class="sirusi-slector" v-show="my_sirusi_selector[index]">
            <a v-on:click="setMySirusi(index+1,0)" :class="(my_sirusi[index] == null || my_sirusi[index] <=  0) ? 'current':''">ー</a>
            <a v-on:click="setMySirusi(index+1,1)" :class="(my_sirusi[index] == 1) ? 'current':''">◎</a>
            <a v-on:click="setMySirusi(index+1,2)" :class="(my_sirusi[index] == 2) ? 'current':''">◯</a>
            <a v-on:click="setMySirusi(index+1,3)" :class="(my_sirusi[index] == 3) ? 'current':''">▲</a>
            <a v-on:click="setMySirusi(index+1,4)" :class="(my_sirusi[index] == 4) ? 'current':''">△</a>
          </div>
          </div>
          <div v-else class="locked" >	
    <img src="/images/icon_lock.svg" alt="" />
    </div>
        </td>
        <td  class="waku" :class="'waku-'+(index+1)"> 
          {{ index+1 }}
         <span v-if="senshu.kjo == 1"><br />欠</span>
        </td>
        
        <td class="tojitsu-yoso">
          <span v-if="senshu.web_info">
            {{ senshu.web_info.curdaystamp == '○'?'◯':senshu.web_info.curdaystamp }}
          </span>
        </td>
        <td>
            {{ senshu.web_info ?senshu.web_info.whiff:''}}
        </td>
        <td>
            {{ senshu.web_info ? senshu.web_info.start:'' }}
        </td>
        
        <td style="padding:0;">
          <img :src="RACER_PHOTO_BASE_URL + senshu.toban+'.jpg'" class="racer-photo" />
        </td>
        <td>
          <router-link class="profile-link" :to="{name:'RacerProfile',params:{toban:senshu.toban,tabname:'kibetsu'}}">{{ senshu.name }}</router-link>
        <br />
          <span class="sub-item"><span class="f-hearts-icon" v-if="senshu.seibetsu==2">&hearts;</span>{{ senshu.toban }} / {{ senshu.kyu }} </span>
        </td>
        <!-- //記者直前予想追加分 -->
        <td class="sp-comment-cell">
            <div class="sp-comment-cell__inner">
            <p style="font-size:12px;">{{ senshu.web_info ? senshu.web_info.curdaycomment:'' }}</p>
            </div>
        </td>
        <!-- //ここまで記者直前予想追加分 -->
        <td>
          {{ senshu.syusin }} / {{ senshu.syussinchi }} <br />
          {{ senshu.nenrei ? senshu.nenrei : '- ' }}歳 / {{ senshu.taiju ? senshu.taiju: '- '}}kg
        </td>
         <td>
          F{{ senshu.fsu }} <br />
          L{{ senshu.lsu }} <br />
          {{ senshu.p_st != null ? Number(senshu.p_st).toFixed(2) : '' }}
        </td>
        <td>
            <span :class="senshu.zsyo_rank == 1 ?'n1':''">{{ senshu.zsyo }}</span> <br />
            <span :class="senshu.z2ren_rank == 1 ?'n1':''">{{ senshu.z2ren }}</span> <br />
            <span :class="senshu.z3ren_rank == 1 ?'n1':''">{{ senshu.z3ren }}</span>
        </td>
         <td>
            <span :class="senshu.jsyo_rank == 1 ?'n1':''">{{ senshu.jsyo }}</span> <br />
            <span :class="senshu.j2ren_rank == 1 ?'n1':''">{{ senshu.j2ren }}</span> <br />
            <span :class="senshu.j3ren_rank == 1 ?'n1':''">{{ senshu.j3ren }}</span>
        </td>
        <td>
            {{ Number(senshu.mno) }} <br />
            <span :class="senshu.m2ren_rank == 1 ?'n1':''">{{ senshu.m2ren }}</span>
        </td>
        <td>
            {{ Number(senshu.bno) }} <br />
            <span :class="senshu.b2ren_rank == 1 ?'n1':''">{{ senshu.b2ren }}</span>
        </td>
 

        <!-- //記者直前予想追加分 -->
        <td class="comment-cell">
            <div class="comment-cell__inner">
            <p style="font-size:13px;">{{ senshu.web_info ? senshu.web_info.curdaycomment:'' }}</p>
            </div>
        </td>
         <!-- //ここまで記者直前予想追加分 -->
      </tr>

      </template>
      </tbody>
    </table>
    </div>
    
      <a v-if="isMobile" class="button tohyo-button" target="blank" :href="'https://www.boatrace.jp/owsp/VoteBridgeSP.jsp?authAfterTrans=stay&amp;voteTagId=voteTag&amp;_hd='+ date +'&amp;_jcd='+ race.jcd + '&amp;_rno='+ race_num ">投票</a>
      <a v-else class="button tohyo-button" target="blank" :href="'https://www.boatrace.jp/owpc/VoteConfirm.jsp?authAfterTrans=stay&amp;voteTagId=vote&amp;_hd='+ date +'&amp;_jcd='+ race.jcd + '&amp;_rno='+ race_num ">投票</a>
    
    <div style="text-align:center;margin:40px auto;">
    <Adsense
        class="adsbygoogle"
        data-ad-client="ca-pub-3076785709839281"
        data-ad-slot="7503353487"
        data-ad-format="auto"
        data-full-width-responsive="true">
    </Adsense>
    </div>
    
    
    </div>
    </template>
    
    <script>
    import JO_ID_NAMES from '../mixins/PrefsMixin';
    import API_BASE_URL  from '../mixins/PrefsMixin';
    import Racenav from '../components/Racenav';
    import pianoSend from '../mixins/PrefsMixin'
    
    
    export default {
      mixins: [ JO_ID_NAMES,API_BASE_URL,pianoSend],
      components: {
        Racenav
      },
      name: 'KisyaYoso',
      data:function(){
        return {
        date:'',
        jo:'',
        race_num:0,
        race:{},
        header:{},
        shussou_senshu:[],
        nidate_length:0,
        jo_name:'',
        title:'報知記者直前予想',
        course:[],
        tommrow:new Date(),
        today:new Date(),
        my_sirusi_current_teiban:-1,
        my_sirusi_selector:[0,0,0,0,0,0],
        my_sirusi:[null,null,null,null,null,null],
        yoso_article:[]
        }
      },
      head:function(){
        return {
          title: function(){
            return {
              inner: this.$data.title,
              separator: ' - ',
              complement: 'BOATNAVI報知'
            }
          }
        }
      },
      computed:{
            isMobile:function(){
              if((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
                  return true;
              }
              return false;
            }
      },
    
     mounted:function(){
       
      },
    
      created:function(){
        this.$data.date = this.$route.params['date'];
        this.$data.race_num = this.$route.params['race'];
        this.$data.jo = this.$route.params['jo'];
        this.$data.tommrow.setDate(this.$data.tommrow.getDate() + 1);
        this.$data.course =[];
        this.$data.yoso_article = [];
        this.getData();
      },
      beforeRouteUpdate(_to, _from, _next) {
    
    
        if(_to.name == 'KisyaYoso'){
    
          this.$data.date = _to.params['date'];
          this.$data.race_num = _to.params['race'];
          this.$data.jo = _to.params['jo'];
          this.$data.my_sirusi = [null,null,null,null,null,null];
          this.$data.yoso_article = [];
          this.changeRace();
        }
        _next();
        
      },
      beforeRouteLeave(_to, _from, _next) {
        _from;
        try{
          document.removeEventListener('click',this.closeMySirusiSelecor,true);
        }catch(err){
          err;
        }
        _next();
       
      },
      methods: {

    
        closeMySirusiSelecor(evt){
    
            if(evt.target.closest('#my_sirusi_selector_'+(this.$data.my_sirusi_current_teiban-1))){
              
              return true;
            }
            
           if(evt.preventdefault){
              evt.preventdefault();
            }
    
            if(evt.stopPropagation){
              evt.stopPropagation();
            }
    
            this.$data.my_sirusi_selector= [0,0,0,0,0,0];
            
            document.removeEventListener('click',this.closeMySirusiSelecor,true);
            return false;
        },
    
        setMySirusi(teiban,sirusi){
          this.$data.my_sirusi_selector= [0,0,0,0,0,0];
       
          this.$data.my_sirusi[teiban-1]= sirusi ;
       
          document.removeEventListener('click',this.closeMySirusiSelecor,true);
    
          let data = {};
          data['sirusi'+teiban] = sirusi;
         
    
          let headers = {headers: {"Authorization": this.$store.getters.user.token }};
              this.axios.post(this.API_BASE_URL + 'user/sirusi/'+ this.$data.date + '/'+ this.$data.jo  +'/'+ this.$data.race_num,
              data, 
              headers
              ) .then((response) => {
                response;
              
              }).catch((e) => { // eslint-disable-line
              
                
                
              });
        },
    
        changeRace(){
          this.$data.race ={};
          this.$data.shussou_senshu=[];
          this.$data.nidate_length=0;
          this.$data.course =[];
          this.getData();
        },
    
        splitKaime(kaime){
          if(kaime == null){
            return '';
          }
          return kaime.replace(/\d/g,"<span class=\"waku-$&\">$&</span>");
        },
    
        getSirusi(teiban){
          if(this.$data.race.zenjitsu_sirusi && this.$data.race.zenjitsu_sirusi.length > 0){
            let sban = this.$data.race.zenjitsu_sirusi.indexOf(teiban);
            if(sban < 4){
              return ['◎','◯','▲','△'][sban];
            } 
          }
          return '';
        },
    
        getProp(object,propertyPath){
      
          if (!object) { return undefined }
          let result = object;
          const propertyArray = propertyPath.split('.');
          for (let i = 0; i <= propertyArray.length - 1; i += 1) {
            if (propertyArray[i] === '' ) { return undefined; }
            if (typeof result[propertyArray[i]] === 'undefined') { return undefined; }
            result = result[propertyArray[i]];
          }
          
          return result;
        },
    
          getData() {
              this.axios.get(this.API_BASE_URL + 'web_info/'+ this.$data.date + '/'+ this.$data.jo  +'/'+ this.$data.race_num)
              .then((response) => {
    
                this.$data.shussou_senshu = response.data.shussou_senshu;
                this.$data.web_info  = response.data.web_info;
                
                this.$data.race = response.data.race;
                this.$data.header = response.data.header;
                if(this.$data.race == null){
                  this.$router.replace({ name:'NotFound'});
                  return;
                }
                
             
               
                this.$data.jo_name = this.JO_ID_NAMES[Number(this.$data.jo) - 1].name;
                
    
                this.$data.title = '報知記者直前予想 - '+ this.$data.jo_name +' '+ this.$data.race.rno +'R '+  this.$data.race.hdate + ' ' + this.$data.race.ktitl; 
                this.$emit('updateHead');
                this.pianoSend('報知記者直前予想',this.$data.jo_name,this.$data.race.rno +'R',this.$data.race.hdate,this.$data.race.ktitl);
    
    
                for(let i=1;i<=9;i++){
                  if(this.$data.race['nidate'+i]){
                    this.$data.nidate_length = i;
                  }
                }
              
               let senshu_length = this.$data.shussou_senshu.length;
               let course = [];
    
               for(let i=0;i<senshu_length ;i++){
                    if(Number.isInteger(this.$data.shussou_senshu[i].cose)){
                        course[this.$data.shussou_senshu[i].cose-1] =(i+1);
                    }
                    let j = 0;
                    while(j<senshu_length){
                        if(this.$data.web_info){
                            if(this.$data.web_info[j] && this.$data.shussou_senshu[i].toban == this.$data.web_info[j].toban){
                                this.$data.shussou_senshu[i].web_info = this.$data.web_info[j];
                                if(this.$data.web_info[j].predaycomment){
                                    this.$data.yoso_article.push(this.$data.web_info[j].predaycomment.replace(/\n/g, '<br>'));
                                }
                            }
                        }
                        j++;
                    }
                    
                }
             
                this.$data.course = course;
    
    
    
              })
              .catch((e) => {  // eslint-disable-line
                
                this.$router.replace({ name:'NotFound'});
              });
    
             if(this.$store.getters.uesr){
               this.getMySirusi(this.$store.getters.uesr.token) 
              return;
             }
              
             this.$cognito.isAuthenticated()
              .then(session => { // eslint-disable-line
                const token = session.idToken.jwtToken
                // get attribute.
                this.$cognito.getAttribute()
                  .then(() => {
                  
                    this.getMySirusi(token) 
                  })
                  .catch(error => { // eslint-disable-line
                   
                    this.$store.commit('setUser', null)
                  })
              })
              .catch(error => { // eslint-disable-line
            
                this.$store.commit('setUser', null)
               })
          },
              openMySirusiSelecor(teiban){
          this.$data.my_sirusi_current_teiban = teiban;
          this.$data.my_sirusi_selector= [0,0,0,0,0,0];
          this.$data.my_sirusi_selector[teiban - 1] = 1;
          document.addEventListener('click',this.closeMySirusiSelecor,true);
        },
          getMySirusi(token){
            
              let headers = {headers: {"Authorization": token}};
              this.axios.get(this.API_BASE_URL + 'user/sirusi/'+ this.$data.date + '/'+ this.$data.jo  +'/'+ this.$data.race_num,
              headers,
              {}
              ) .then((response) => {
                if(response.data && response.data.user_sirusi){
                  this.$data.my_sirusi = response.data.user_sirusi.sirusi;
                }
              
              }).catch((e) => { // eslint-disable-line
                
              });
          },
          printMySirusi(sirusi){
          if(sirusi != null && sirusi-1 >= 0 && sirusi-1 <= 3){
            return ['◎','◯','▲','△'][sirusi-1];
          }
          return 'ー';
         }
      }
    }
    </script>
    <style lang="scss" scoped>
    th.comment-cell,
    td.comment-cell{
      text-align: left;
      display:table-cell;
    }
    th.sp-comment-cell,
    td.sp-comment-cell{
      display:none;
      text-align: left;
    }
    .n1{
       color:#e02a2a; 
    }
    img.racer-photo{
      max-width:none;
      height:73px;
    }
    @media screen and (max-width:375px) { 
      img.racer-photo{
      height:56px;
      }
    }
    
    .sirusi-slector{
      padding:10px;
      background:#EFEFEF;
      position:absolute;
      z-index:2;
      height:48px;
      top:50%;
      margin-top:-24px;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.13), 0 1px 5px 0 rgba(0,0,0,0.08);
      a{
        display:inline-block;
        width:48px;
        height:28px;
        border:1px solid #CDCDCD;
        line-height:28px;
        margin:0 5px;
        &:first-child{
          color:#aaa;
        }
        &.current{
           background-color: #f3ff86; 
        }
            &:hover,&:focus{
          background-color: #f3ff86;
        }
         &:active{
          background-color: #f3ff86;
           box-shadow: 0 0px 0px 0 rgba(0,0,0,0.13), 0 1px 5px 0 rgba(0,0,0,0.08);
        }
      }
    }
    td.my-sirusi{
      position: relative;
      .open-sirusi-button{
        display:inline-block;
        width:28px;
        height:28px;
        border:1px solid #CDCDCD;
        line-height:28px;
        background-color: #EFEFEF;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.13), 0 1px 5px 0 rgba(0,0,0,0.08);
        &:hover,&:focus{
          background-color: #f3ff86;
        }
         &:active{
          background-color: #f3ff86;
           box-shadow: 0 0px 0px 0 rgba(0,0,0,0.13), 0 1px 5px 0 rgba(0,0,0,0.08);
        }
        &.notset{
          color:#ccc;
        }

      }
      .locked{
        img{
          width:24px;
          opacity: 0.2;
        }
      }
    
    }
    td.my-sirusi,
    th.my-sirusi{
      width:47px;
    }
    .kisya-yoso-column{
      border:1px solid #CCCCCC;
      border-radius: 5px;
      padding:10px 20px;
      background: url(/images/yoso_bg.png);
      background-position: right -200px bottom -150px;
      background-size: 740px;
      background-repeat: no-repeat;
      &__inner{
          max-width:900px;
        }
      p{
        font-size:15px;
        word-break: auto-phrase;
      }
      h2{
        font-size:21px;
        font-weight: 700;
        border-bottom:1px solid #F48E17;
        padding:10px 0;
        margin-bottom:13px;
        .hochi-logo{
          width:110px;
          margin-top:-5px;
          color:#004B72;
          display:inline-block;
          vertical-align: middle;
        }
      }
    }

    
    @media screen and (max-width:430px) { 
      th.sp-comment-cell,
      td.sp-comment-cell{
        display:table-cell;
      }

      th.comment-cell,
      td.comment-cell{
        display:none;
      }

      .kisya-yoso-column{
        background: url(/images/yoso_bg.png);
        background-position:right -70px  bottom -60px;
        background-size: 280px;
        background-repeat: no-repeat;
        padding-bottom:40px;
      }
    }

    th.sp-comment-cell{
      padding:10px;
    }
    td.sp-comment-cell{
      white-space:normal;
      p{
      margin-bottom:0;
      } 
      div.sp-comment-cell__inner{
        width:80vw;
        padding:10px;
      }
    }

    td.comment-cell{
      white-space:normal;
      
     p{
      margin-bottom:0;
     } 
     div.comment-cell__inner{
        max-width:640px;
        text-align: left;
        padding: 10px 10px;
      }
      @media screen and (min-width:768px) {
        div.comment-cell__inner{
          min-width:500px;
        }
      }
    }

    th.text-vertical {
      padding:0 5px;
    }
    th.text-vertical span{
      display: inline-block;
      
      writing-mode: vertical-rl;
      text-align: center;
      width:20px;
      margin:0 auto;
    }



    @media screen and (max-width:430px) { 
      th.text-vertical {
      padding: 0 5px 0 3px;
    }

    
      th.text-vertical span{
        width:18px;
      }

    }



    </style>